import { render } from "./Campaigns.vue?vue&type=template&id=3dd73b66"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__